<template>
  <a href="#" class="value-teaser" :class="customClass" @click="clickHandler" draggable="false" ondragstart="return false;">
    <div class="image-box">
      <video src="../assets/media/kundenorientierung.mp4" autoplay loop playsinline muted v-if="isVisible && index === 0" />
      <video src="../assets/media/innovation.mp4" autoplay loop muted playsinline v-if="isVisible && index === 1" />
      <video src="../assets/media/verlaesslichkeit.mp4" autoplay loop muted playsinline v-if="isVisible && index === 2" />
      <video src="../assets/media/nachhaltigkeit.mp4" autoplay loop muted playsinline v-if="isVisible && index === 3" />
    </div>
    <div class="hover-box">
      <img src="../assets/images/values/kachel-01.jpg" alt="" v-if="isVisible && index === 0" draggable="false" ondragstart="return false;">
      <img src="../assets/images/values/kachel-02.jpg" alt="" v-if="isVisible && index === 1" draggable="false" ondragstart="return false;">
      <img src="../assets/images/values/kachel-03.jpg" alt="" v-if="isVisible && index === 2" draggable="false" ondragstart="return false;">
      <img src="../assets/images/values/kachel-04.jpg" alt="" v-if="isVisible && index === 3" draggable="false" ondragstart="return false;">
    </div>
    <div class="text-box">
      <h3>{{title}}</h3>
      <p>{{copy}}</p>
    </div>
  </a>
</template>

<script>
import MobileDetect from "mobile-detect";
export default {
  name: "ValueTeaser",
  data() {
    return {
      mobile: false
    }
  },
  props: {
    title: String,
    copy: String,
    hoverColor: String,
    index: Number,
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  methods: {
    clickHandler() {
      this.$emit('click', this.index);
    }
  },
  mounted() {
    const detect = new MobileDetect(window.navigator.userAgent);
    this.mobile = detect.mobile();
  },
  computed: {
    customClass() {
      let c = this.mobile ? 'mobile ' + this.hoverColor : this.hoverColor;
      if (this.isVisible) {
        c += ' visible';
      }
      return c;
    }
  }
}
</script>

<style scoped>
  .value-teaser {
    position: relative;
    display: block;
    width: 340px;
    margin-right: 40px;
    overflow: hidden;
    opacity: 0;
    transform: scale(0.6) translate3d(0, 0, 0);
  }
  .value-teaser.visible {
    opacity: 1;
    transform: scale(1) translate3d(0, 0, 0);
  }
  .value-teaser:nth-child(1) {
    transition: 0.4s ease 0.4s;
  }
  .value-teaser:nth-child(2) {
    transition: 0.4s ease 0.5s;
  }
  .value-teaser:nth-child(3) {
    transition: 0.4s ease 0.6s;
  }
  .value-teaser:nth-child(4) {
    transition: 0.4s ease 0.7s;
  }
  .value-teaser:before {
    content: "";
    position: relative;
    display: block;
    padding-top: 100%;
  }
  .image-box, .text-box, .hover-box {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .image-box:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(20deg, #B1D995 0%, #3CB2B8 100%);
    opacity: 0.75;
  }
  .text-box {
    padding: 20px 28px;
    transform: translate3d(0, 50%, 0);
    transition: 0.4s cubic-bezier(0.33, 1, 0.68, 1);
    color: #102D61;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  h3 {
    position: relative;
    display: inline-block;
    margin: 0;
    font-size: 24px;
    top: 0;
    left: 0;
    transform: translate3d(0, 0, 0);
    transition: top 0.4s ease, left 0.4s ease, transform 0.4s ease;
  }
  p {
    margin: 12px 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
    opacity: 0;
    transition: opacity 0.25s ease;
  }
  .value-teaser:not(.mobile):hover .text-box {
    transform: translate3d(0, 0, 0);
  }
  .value-teaser:not(.mobile):not(:hover) h3, .value-teaser.mobile h3 {
    top: -20px !important;
    left: 50% !important;
    transform: translate3d(-50%, -50%, 0) !important;
  }
  .value-teaser:not(.mobile):hover p {
    opacity: 1;
    transition: opacity 0.3s linear 0.2s;
  }
  img {
    position: relative;
    display: block;
    width: 100%;
    transform: translate3d(0, 100%, 0) scale(1);
    transition: 0.3s cubic-bezier(0.61, 1, 0.88, 1);
  }
  .value-teaser:not(.mobile):hover .hover-box:before, .value-teaser:not(.mobile):hover img {
    transform: translate3d(0, 0, 0);
  }
  .value-teaser:not(.mobile):hover img {
    transition: 0.3s cubic-bezier(0.33, 1, 0.68, 1) 0.1s;
  }
  .blue:not(.mobile):hover .text-box, .pink:not(.mobile):hover .text-box, .blue p, .pink p {
    color: white;
  }
  video {
    width: 100%;
    height: 100%;
  }
  @media(max-width: 1199px), (max-height: 799px) {
    .value-teaser {
      width: 300px;
      min-width: 300px;
      margin-right: 30px;
    }
    p {
      font-size: 14px;
    }
    .text-box {
      padding: 18px 22px;
    }
  }
  @media(max-width: 999px) {
    .value-teaser {
      min-width: 280px;
    }
    .value-teaser:last-child {
      margin-right: 50px;
    }
  }
  @media(max-width: 567px) {
    .value-teaser {
      min-width: 240px;
      margin-right: 20px;
    }
    h3 {
      font-size: 20px;
    }
  }
</style>